import type { ProfilePlan } from '../api/profile'
import type { Plan } from '../api/subscriptionPlans'

export type PlanPurchaseAction = 'purchase' | 'upgrade'

const INACTIVE_PLAN_NAMES = new Set(['', '未开通', '未订阅'])

export function hasActiveSubscription(plan: ProfilePlan): boolean {
  return !INACTIVE_PLAN_NAMES.has(plan.planName.trim())
}

function isPlanPurchasable(plan: Plan): boolean {
  return plan.limitMax == null || plan.limitPurchased == null || plan.limitPurchased < plan.limitMax
}

/** 根据当前订阅与目录判断应展示「购买」还是「升级」；无需操作时返回 null。 */
export function resolvePlanPurchaseAction(
  profilePlan: ProfilePlan,
  catalog: Plan[],
): PlanPurchaseAction | null {
  const purchasable = catalog.filter(isPlanPurchasable)
  if (purchasable.length === 0) return null

  if (!hasActiveSubscription(profilePlan)) {
    return 'purchase'
  }

  const current =
    catalog.find((item) => item.name === profilePlan.planName.trim()) ?? null
  const currentPrice = current?.priceYuan ?? 0
  const hasHigherTier = purchasable.some((item) => item.priceYuan > currentPrice)
  return hasHigherTier ? 'upgrade' : null
}
